import { ReactNode } from 'react'
import { classNames } from '../../_helpers'

type PropTypes = {
  imageUrl?: string | null
  title?: string | null
  className?: string
  children?: ReactNode
}

// Zeigt das Festival-Bild, ohne Bild einen neutralen Farbverlauf mit Initiale
export const FestivalImage = ({ imageUrl, title, className, children }: PropTypes) => {
  return (
    <div className={classNames('relative overflow-hidden bg-primary-200', className)}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={''}
          className={'h-full w-full object-cover'}
        />
      ) : (
        <div className={'flex h-full w-full items-center justify-center bg-linear-to-br from-primary-200 via-primary-100 to-primary'}>
          <span
            aria-hidden={'true'}
            className={'text-8xl font-extrabold text-white/15 select-none'}
          >
            {(title || '').trim().slice(0, 1).toUpperCase()}
          </span>
        </div>
      )}
      <div className={'absolute inset-0 bg-linear-to-t from-primary-200/70 via-transparent to-transparent'} />
      {children}
    </div>
  )
}
